var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2Mail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 595.28",
    style: {
      enableBackground: "new 0 0 595.28 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M553.81,127.47H43.35c-15.59,0-28.24,12.64-28.24,28.24v283.86c0,15.59,12.64,28.24,28.24,28.24h510.46 c15.59,0,28.24-12.64,28.24-28.24V155.71C582.05,140.11,569.4,127.47,553.81,127.47z M43.35,165.79l168.47,114.56L43.35,428.13 V165.79z M78.75,155.71h441.74l-220.87,150.2L78.75,155.71z M235.94,296.75l53.61,36.46c2.68,2.63,6.24,4.04,9.86,4.04 c2.73,0,5.5-0.79,7.93-2.44l54.79-37.26l161.9,142.02H73.13L235.94,296.75z M386.25,281.14L553.81,167.2v260.93L386.25,281.14z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Mail);
export default __webpack_public_path__ + "static/media/2-mail.cd209085ccc9c0a470a80ac4f4525343.svg";
export { ForwardRef as ReactComponent };